'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabEvents = exports.TicketEvents = exports.ContextFactory = undefined;
exports.createContext = createContext;
exports.registerEventHandlers = registerEventHandlers;

var _ContextFactory = require('./ContextFactory');

var _ContextFactory2 = _interopRequireDefault(_ContextFactory);

var _eventsTicket = require('./eventsTicket');

var TicketEvents = _interopRequireWildcard(_eventsTicket);

var _eventsTab = require('./eventsTab');

var TabEvents = _interopRequireWildcard(_eventsTab);

var _eventsObject = require('./eventsObject');

var ObjectEvents = _interopRequireWildcard(_eventsObject);

var _EventHandler = require('../Core/EventHandler');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ContextFactory = _ContextFactory2.default;
exports.TicketEvents = TicketEvents;
exports.TabEvents = TabEvents;

/**
 * @function
 *
 * @param {AppEventEmitter} outgoingDispatcher
 * @param {AppEventEmitter} incomingDispatcher
 * @param {InstanceProps} instanceProps
 * @param {ContextProps} contextProps
 * @return {Context}
 */
/**
 * This modules handles the creation of specific application contexts
 *
 * @module Context
 */

function createContext(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps) {
  return _ContextFactory2.default.create(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps);
}

/**
 * Registers helpdesk window events with the event dispatching system
 *
 * @function
 *
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, TabEvents.EVENT_TAB_DATA, TabEvents.props.EVENT_TAB_DATA);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, TabEvents.EVENT_TAB_ACTIVATE, TabEvents.props.EVENT_TAB_ACTIVATE);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, TabEvents.EVENT_TAB_CLOSE, TabEvents.props.EVENT_TAB_CLOSE);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, ObjectEvents.EVENT_CONTEXT_PROPERTY_GET, ObjectEvents.props.EVENT_CONTEXT_PROPERTY_GET);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/index.js
// module id = 105
// module chunks = 0